"use client";

import { useTranslations } from "next-intl";
import { brandConfig } from "@/config/brand";

/** Copyright text. The year is passed from the server (footer) so SSR and client
 * render the same value — avoids a New-Year clock mismatch / React hydration error #418. */
export function CopyrightText({ year }: { year?: number }) {
	const t = useTranslations("footer");
	const displayYear = year ?? new Date().getFullYear();
	return (
		<>
			{t("copyright", {
				year: displayYear,
				company: brandConfig.copyrightHolder,
				allRightsReserved: t("allRightsReserved"),
			})}
		</>
	);
}
